import { Button, Heading } from 'applaus-ui-kit'
import { Dispatch, SetStateAction } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { balanceWithdrawal } from '../../../../api/events/balanceWithdrawal'
import { ListPartnersResponse } from '../../../../api/partner/listPartners'
import {
  clearModalAction,
  setAlertModalAction
} from '../../../../redux/AlertModal/actions'
import { clearLoading, setLoading } from '../../../../redux/Loading/actions'
import { ReduxState } from '../../../../redux/rootReducer'
import { formatPrice } from '../../../../utils/formatPrice'
import { sleep } from '../../../../utils/sleep'
import * as S from './BalanceWithdrawal.styles'

type AddPartnerProps = {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  eventPartners: ListPartnersResponse[] | undefined
}

export const BalanceWithdrawal = ({
  open,
  setOpen,
  eventPartners
}: AddPartnerProps) => {
  const dispatch = useDispatch()
  const { summaryData, eventData } = useSelector(
    (state: ReduxState) => state.ManageEventReducer
  )
  const { userInfo } = useSelector((state: ReduxState) => state.UserReducer)

  const distributeBalance = async () => {
    dispatch(setLoading())
    await sleep(2000)
    try {
      const status = await balanceWithdrawal(eventData!.id)

      if (status === 200) {
        dispatch(
          setAlertModalAction({
            buttonText: 'Ok',
            open: true,
            title: 'Pedido de distribuição feito com sucesso.',
            variant: 'success',
            click: () => {
              dispatch(clearModalAction())
              setOpen(false)
            }
          })
        )
      }
      dispatch(clearLoading())
    } catch (e: any) {
      dispatch(clearLoading())
      if (e.response.data.message === 'ongoing event') {
        setOpen(false)
        dispatch(
          setAlertModalAction({
            buttonText: 'Ok',
            open: true,
            title: 'Evento em andamento, aguarde a finalização do evento.',
            variant: 'error',
            click: () => {
              dispatch(clearModalAction())
            }
          })
        )
      } else {

        const { message } = e.response.data;

        const messageTranslations: { [key: string]: string } = {
          'The balance of this wind has already been distributed': 'O saldo já foi distribuído.',
          'There is no balance to distribute': 'Não há saldo para ser distribuído.',
          'insufficient available balance to withdrawal. Contact support.': 'Saldo disponível é insuficiente para saque. Entre em contato com o suporte.',
          'insufficient balance to withdrawal. Contact support.': 'Saldo insuficiente para saque. Entre em contato com o suporte.'
        };
        
        const alertDescription: string = messageTranslations[message] || 'Tente novamente.';
        
        dispatch(
          setAlertModalAction({
            buttonText: 'Ok',
            open: true,
            title: 'Ocorreu um erro na distribuição.',
            description: alertDescription,
            variant: 'error',
            click: () => {
              dispatch(clearModalAction())
            }
          })
        )
      }
    }
  }

  const filteredPartners = eventPartners?.map((partner) => {
    const findIndex = partner.events.findIndex(
      (event) => event.event.id === eventData!.id
    )

    if (findIndex > -1) {
      return partner.events[findIndex].revenuePercent
    } else return null
  })

  const percentagePartner = (partner: ListPartnersResponse) => {
    const eventsLength = partner.events.filter(
      (event) => event.event.id === eventData!.id
    )
    const percentage =
      eventsLength.length === 1 ? eventsLength[0].revenuePercent + '%' : '0%'

    return percentage
  }

  return (
    <S.Container open={open}>
      <S.Wrapper>
        <S.CloseIcon onClick={() => setOpen(false)} />
        <div className="title">
          <Heading variant="h5">Distribuir ganhos</Heading>
        </div>

        <div className="totalBox">
          <Heading variant="h5" className="purpleColor">
            Total
          </Heading>

          <Heading variant="h5" className="purpleColor">
            {formatPrice(summaryData?.summary.confirmedPayments ?? 0)}
          </Heading>
        </div>

        <div className="partnersBox">
          <div className="partner">
            <Heading variant="h5" className="regular purpleColor">
              {userInfo ? userInfo?.firstName + ' ' + userInfo?.lastName : ''}
            </Heading>
            <Heading variant="h5" className="regularPercent">
              {filteredPartners && filteredPartners!.length > 0
                ? 100 - filteredPartners!.reduce((p, c) => p! + c!, 0)! + '%'
                : '100%'}
            </Heading>
            <Heading variant="h5" className="purpleColor regularPrice">
              {filteredPartners && filteredPartners!.length > 0
                ? formatPrice(
                    ((100 - filteredPartners.reduce((p, c) => p! + c!, 0)!) *
                      summaryData?.summary.confirmedPayments!) /
                      100
                  )
                : formatPrice(summaryData?.summary.confirmedPayments!)}
            </Heading>
          </div>
          {eventPartners?.map((partner) => (
            <div key={partner.id} className="partner">
              <Heading variant="h5" className="regular">
                {partner.name}
              </Heading>
              <Heading variant="h5" className="regularPercent">
                {percentagePartner(partner) ?? '0'}
              </Heading>
              <Heading variant="h5" className="purpleColor regularPrice">
                {formatPrice(
                  partner.events.filter(
                    (event) => event.event.id === eventData!.id
                  ).length > 0
                    ? (partner.events.filter(
                        (event) => event.event.id === eventData!.id
                      )[0].revenuePercent *
                        summaryData?.summary.confirmedPayments!) /
                        100
                    : 2
                )}
              </Heading>
            </div>
          ))}
        </div>

        <div className="button">
          <Button
            size="large"
            color="primary"
            variant="contained"
            fullWidth={false}
            onClick={distributeBalance}>
            Distribuir
          </Button>
        </div>
      </S.Wrapper>
    </S.Container>
  )
}
